import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SecurityDepositListRes;
export const SecurityDepositListTodo = createAsyncThunk('SecurityDepositList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'security_deposit',
            params:{
                "user_id": localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return SecurityDepositListRes = res.data

    } catch (error) {
        return SecurityDepositListRes = error.response.data
    }
})

const SecurityDepositListSlice = createSlice({
    name: 'SecurityDepositList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SecurityDepositListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(SecurityDepositListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SecurityDepositListSlice.reducer; 